import { render } from "./ContactsEntityContactInfoEditor.vue?vue&type=template&id=2696ef52"
import script from "./ContactsEntityContactInfoEditor.vue?vue&type=script&lang=js"
export * from "./ContactsEntityContactInfoEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__